module.exports = __webpack_public_path__ + "static/scale-model-of-san-felipe-de-neri-church-in-albuquerque-new-mexico-d22544c6e7a2791bf4256a127b3a3fef.png";